// extracted by mini-css-extract-plugin
export default {"textArea":"TextArea_textArea__tf5w3","inputBox":"TextArea_inputBox__+ml6R","sendButton":"TextArea_sendButton__WdHXy"};